<script>
  import { createEventDispatcher } from "svelte";

  export let isActive;
  export let label

  const dispatch = createEventDispatcher();
</script>

<button 
  type="button"
  class="toggle-video-button"
  class:active={isActive}
  on:click={() => dispatch('toggle')}
>
  {#if isActive}
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="white"/>
      <path d="M10.9 6.78756C11.8333 7.32642 11.8333 8.67358 10.9 9.21244L7.6 11.1177C6.66667 11.6566 5.5 10.983 5.5 9.90526V6.09475C5.5 5.01703 6.66667 4.34345 7.6 4.88231L10.9 6.78756Z" fill="#2B50ED"/>
    </svg>
  {:else}
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="16" height="16" rx="8" fill="#2B50ED"/>
      <path d="M10.9 6.78756C11.8333 7.32642 11.8333 8.67358 10.9 9.21244L7.6 11.1177C6.66667 11.6566 5.5 10.983 5.5 9.90526V6.09475C5.5 5.01703 6.66667 4.34345 7.6 4.88231L10.9 6.78756Z" fill="white"/>
    </svg>
  {/if}
  <span>{label}</span>        
</button>

<style lang="scss">
  .toggle-video-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    grid-gap: 4px;
    padding: 5px 10px;
    border-radius: 30px;
    font-size: 10px;
    font-weight: 600;
    line-height: 14px;
    letter-spacing: 0.04em;
    border: none;
    background-color: #EFF1FD;
    color: #2B50ED;

    &.active {
      background-color: #2B50ED;
      color: white;
    }

    span {
      text-transform: uppercase;
    }
  }
</style>